<template>
<v-app id="inspire">

    <v-main style="background-color: #24292d; font-family: 'Poppins', sans-serif !important;">
      <cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only" />

      <v-container fluid fill-height align-start>
      <v-row>
          <v-col md="12" lg="12" cols="12">
            <v-card>
          <v-card-title> Filtros</v-card-title>
          <v-card-text>
                <v-row>
                                       <v-col md="3" lg="3" cols="12">
                                           <vue-excel-xlsx
                                               class   = "btn"
    :data="listas"
    :columns="columns"
    :filename="'Lista Reserva'"

    >
   <v-btn> Bajar Excel</v-btn>
</vue-excel-xlsx>
 </v-col>
              </v-row>
          </v-card-text>
      </v-card>
          </v-col>
      </v-row>
    <v-row >
      <v-col md="12" lg="12" cols="12">
        <v-alert
        :value="alertborrador"
        color="red"
        dark
        dismissible
        border="top"
        transition="scale-transition"
      >
      Su Invitado se borro con éxito.
       </v-alert>
       <v-alert
        :value="alertnuevo"
        color="primary"
        dark
        dismissible
        border="top"
        transition="scale-transition"
      >
      Su Invitado se agrego con éxito.
       </v-alert>
       <v-alert
        :value="alerteditar"
        color="green"
        dark
        dismissible
        border="top"
        transition="scale-transition"
      >
      Su Invitado se edito con éxito.
       </v-alert>
        <v-data-table
      :headers="headers"
      :items="listas"
      class="elevation-1"
      :search="search"
    >
      <template v-slot:top>
        <v-toolbar flat >
          <v-toolbar-title>Lista de Reserva</v-toolbar-title>
          <v-progress-circular
        indeterminate
        v-if="progr == true"
        color="primary"
      ></v-progress-circular>
          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>
          <v-text-field v-model="search" label="Buscar" class="mx-4"></v-text-field>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on }">
              <v-btn color="primary" dark class="mb-2" v-on="on">Nueva Reserva</v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="12">
                      <v-text-field v-if="editedIndex > -1" v-model="editedItem.Nombre" label="Nombre de Reserva"></v-text-field>
                      <v-textarea v-if="editedIndex == -1"  v-model="editedItem.Nombre" rows="10" ></v-textarea>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
                <v-btn color="blue darken-1" text @click="save">Grabar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogdelete" persistent max-width="350">
        <v-card>
          <v-card-title class="headline">Desea eliminar esta Fiesta?</v-card-title>
          <v-card-text>Estos datos no se volveran a visualizar en el sistema.</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="close">No</v-btn>
            <v-btn color="primary darken-1" text @click="borralo">SI</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:[`item.action`]="{ item }">
          <v-icon
          small
          color="blue"
          class="mr-2"
          @click="editItem(item)"
        >
          fas fa-edit
        </v-icon>
        <v-icon
          small
          color="error"
          @click="deleteItem(item)"
        >
          fas fa-minus-circle
        </v-icon>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="damelistas">Cargar de Nuevo</v-btn>
      </template>
    </v-data-table>
      </v-col>
    </v-row>
    <leftmenu :abreviado="abreviado" />
  </v-container>
    </v-main>
  </v-app>
</template>
<script>
import { mapGetters } from "vuex";
import leftmenu from '../../general/leftmenu';
import axios from 'axios';
import firebase from 'firebase/compat/app';
import Cabecerabaja from "@/components/general/cabecerabaja";

export default {
  title: 'Lista de Reserva | Tunay Mi acceso de bolsillo',

  components: {
    Cabecerabaja,
    leftmenu,
  },
    data: () => ({
      drawer: null,
      idreserva: 0,
      idfiesta: 0,
      idfiestaxls:0,
      idtipolista: 0,
      abreviado:'NN',
      fiestas:[],
      tiposlista: [],
      bajaremos: [],
      columns : [
                    {
                        label: "Nombres",
                        field: "Nombre",
                    },
                ],
      progr: true,
      alertborrador: false,
      alertnuevo: false,
      alerteditar: false,
      dialog: false,
      dialogdelete: false,
          date: new Date().toISOString().substr(0, 10),
              menu1: false,

      listas: [],
token:'',
      search: '',
      editedIndex: -1,
      editedItem: {
 idReserva: 0,
      Nombre: ''
    },
      defaultItem: {
 idReserva: 0,
      Nombre: ''
    },
headers: [
                { text: 'Acciones', value: 'action', sortable: false },
        { text: 'Nombre', align: 'left',  value: 'Nombre'},
      ]
  }),
  mounted (){
    this.negocio = this.negocios.find(x=>x.tag ===this.idnegocio)
            if (this.usuario.id === undefined){

              this.overlay = true
              firebase
                  .auth()
                  .onAuthStateChanged(user => {
                    if(user){
                      this.overlay = false
                      this.idreserva =  this.$route.params.idreserva
                      this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
                      this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno

                      this.damelistas();
                    }else{
                      this.overlay = false
                      this.$router.push({ path: '/' });
                    }
                  })
          }else{
              this.idreserva =  this.$route.params.idreserva
              this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
              this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno

              this.damelistas();
          }
  },
   watch: {
    dialog (val) {
      val || this.close()
    },
    "$route.params.idreserva"(value) {
          console.log(value);
          this.negocio = this.negocios.find(x=>x.tag ===this.idnegocio)
             if (this.usuario.id === undefined){
               this.$router.push({name: 'homepage'});
          }else{
               this.idnegocio =  this.$route.params.idnegocio
               this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
               this.damelistas();
               this.damefiestas();
               this.dametiposlista();

             }
    },
  },
  methods : {
    cambia(){
    },
    damelistas(){
      this.progr = true;
                  let urlreserva = 'listareserva/' + this.idreserva ;

        axios
        .get(urlreserva,{
          headers: {
            'Authorization': `Bearer ${this.token}`,
          }
        })
        .then(response => {
            this.listas = response.data;
            this.progr = false;
            this.alertborrador = false;
            this.alertnuevo = false;
            this.alerteditar = false;
        })
        .catch((error)  => {
        console.log(error);
        });
    },
    editItem (item) {
      this.editedIndex = this.listas.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    deleteItem (item) {
      this.editedIndex = this.listas.indexOf(item);
      this.dialogdelete = true;
    },
    close () {
      this.dialog = false;
      this.dialogdelete = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    save () {
      if (this.editedIndex > -1) {
        Object.assign(this.Reservas[this.editedIndex], this.editedItem);
       axios
      .post('editarreserva',{
                    idreserva: this.editedItem.idReserva,
                    idespacio: this.editedItem.idEspacio.idEspacio,
                    idfiesta: this.editedItem.idFiesta.idFiesta,
                    reserva: this.editedItem.Reserva,
                    observacion: this.editedItem.Observaciones
            },{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      }).then(response => {
                console.log(response);
                this.alerteditar = true;
                this.damelistas();
                })
            .catch(error => {
                    this.error = "Hubo un error";
                    console.log(error);
                });
      } else {
           axios
      .post('nuevolistareserva',{
                    idReserva: this.idreserva,
                    nombres: this.editedItem.Nombre
            },{
          headers: {
            'Authorization': `Bearer ${this.token}`,
          }
        }).then(response => {
                this.damelistas();
                this.alertnuevo = true;
                console.log(response);
                })
            .catch(error => {
                    this.error = "Hubo un error";
                    console.log(error);
                });
      }
      this.close()
    },
    borralo (){
      axios
      .delete('personalista',{
        params: {idListaDetalle: this.listas[this.editedIndex].idListaDetalle}
      },{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      })
      .then(response => {
                console.log(response);
                 this.dialogdelete = false;
        this.alertborrador = true;
        this.damefiestas();
                })
      .catch(error => {
                    this.error = "Hubo un error";
                    console.log(error);
                });
    },
  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    formTitle () {
      return this.editedIndex === -1 ? 'Agregar Invitados a Reserva' : 'Editar Reserva'
    },
    computedDateFormatted () {
      return this.formatDate(this.date)
    },
    ...mapGetters({
      user: "user",
      usuario: "usuario",
      negocios: "negocios"
    })
  }
};
</script>
